import React from 'react'

const MissionVission = () => {
  return (
    <div className="about-us">
        <div data-aos="fade-left" className="about-us-title text-center">
          
        </div>
        <div className="about-us-content">
          <div className="container">
            <div className="content-wrapper" style={{ textAlign: "center" }}>
             <div data-aos="fade-down">
             <h2 className="text-regular" style={{ color: "#2d2d2d" }}>
                Mission
              </h2>
              <p className="text-light" style={{ marginTop: "15px", textAlign: "justify" }}>
                The mission of Feroz Law Academy is to provide high-quality legal education and
                training, fostering a learning environment that empowers students to become
                knowledgeable, ethical, and socially responsible legal professionals. Through
                innovative teaching methods, practical experiences, and a commitment to academic
                excellence, we aim to equip our students with the skills and insights necessary for
                success in the legal profession and beyond.
              </p>
             </div>
             <div data-aos="fade-up">
             <h2 className="heading-regular" style={{ color: "#2d2d2d" }}>
                Vision
              </h2>
              <p className="text-light" style={{ marginTop: "15px", textAlign: "justify" }}>
                Feroz Law Academy envisions itself as a leading institution in legal education,
                recognized for its commitment to producing competent, compassionate, and
                justice-oriented legal professionals. We strive to create an inclusive and diverse
                community of learners, fostering intellectual curiosity and a passion for justice.
                Our vision extends beyond academic excellence to encompass the holistic development
                of individuals who will contribute positively to the legal profession and society at
                large.
              </p>
             </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default MissionVission
